/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Create_TitleInputs */

const en_job_form_create_title = /** @type {(inputs: Job_Form_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create New Job`)
};

const de_job_form_create_title = /** @type {(inputs: Job_Form_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Stelle anlegen`)
};

/**
* | output |
* | --- |
* | "Create New Job" |
*
* @param {Job_Form_Create_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_create_title = /** @type {((inputs?: Job_Form_Create_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Create_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_create_title(inputs)
	return en_job_form_create_title(inputs)
});